import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

export type MediaKindFilter = 'image' | 'audio' | 'video' | 'unknown';

export function mediaKindFromMime(mime?: string | null): MediaKindFilter {
    if (!mime) return 'unknown';
    const normalized = mime.toLowerCase();
    if (normalized.startsWith('image/')) return 'image';
    if (normalized.startsWith('audio/')) return 'audio';
    if (normalized.startsWith('video/')) return 'video';
    return 'unknown';
}

type MediaFilePreviewProps = {
    src: string;
    mimeType?: string | null;
    alt?: string;
    compact?: boolean;
    sx?: SxProps<Theme>;
};

const MediaFilePreview: React.FC<MediaFilePreviewProps> = ({
    src,
    mimeType,
    alt = '',
    compact = false,
    sx,
}) => {
    const kind = mediaKindFromMime(mimeType);
    if (kind === 'video') {
        return (
            <Box
                component="video"
                src={src}
                controls={!compact}
                muted={compact}
                preload="metadata"
                sx={{
                    maxWidth: compact ? 80 : 280,
                    maxHeight: compact ? 48 : 200,
                    objectFit: 'contain',
                    ...sx,
                }}
            />
        );
    }
    if (kind === 'audio') {
        return (
            <Box
                component="audio"
                src={src}
                controls
                preload="metadata"
                sx={{ width: compact ? 140 : 280, maxWidth: '100%', ...sx }}
            />
        );
    }
    return (
        <Box
            component="img"
            src={src}
            alt={alt}
            sx={{
                width: compact ? 48 : undefined,
                height: compact ? 48 : undefined,
                maxWidth: compact ? 48 : 280,
                maxHeight: compact ? 48 : 200,
                objectFit: 'contain',
                ...sx,
            }}
        />
    );
};

export default MediaFilePreview;
